var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h223.379v168.207H-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#c0eccb",
    stroke: "#fff",
    cy: 20.989,
    cx: 21,
    fillOpacity: "null",
    strokeOpacity: "null",
    strokeWidth: 1.5,
    r: 19.878
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.954 29.242c-3.736 0-6.777-2.97-6.777-6.617 0-2.23 1.178-4.334 3.094-5.552l-.488-.959-6.846 7.035c-.066.068-.157.028-.253.028h-3.62c-.36 3.634-3.255 5.99-6.73 5.99-3.735 0-6.775-2.89-6.775-6.536 0-3.647 3.04-6.618 6.775-6.618 1.375 0 2.69.393 3.824 1.156l2.082-2.4-1.102-2.495h-2.385c-.193 0-.453-.085-.453-.273v-.717c0-.188.26-.372.453-.372h5.707c.193 0 .357.184.357.372v.717c0 .188-.164.274-.357.274h-1.758l4.06 9.077 6.5-6.67c-.083-1.882-1.011-3.446-2.096-3.446-.192 0-.299-.153-.299-.341v-.716c0-.189.107-.34.3-.34 1.976 0 3.445 2.116 3.508 4.936l.872 1.68a6.856 6.856 0 012.407-.434c3.736 0 6.775 2.965 6.776 6.61 0 3.648-3.04 6.611-6.776 6.611zM10.334 17.4c-2.947 0-5.343 2.32-5.343 5.196 0 2.875 2.396 5.175 5.342 5.175 2.682 0 4.937-1.867 5.289-4.593H9.539c-.137 0-.26-.002-.318-.123-.057-.12-.036-.187.052-.288l3.949-4.522a5.387 5.387 0 00-2.888-.845h0zm1.554 4.415h3.735c-.142-.908-.598-1.996-1.31-2.774l-2.425 2.774zm4.989-5.646l-1.628 1.833a6.67 6.67 0 011.817 3.813h2.365l-2.554-5.646zm15.077 1.252c-.603 0-1.191.097-1.755.29l2.394 4.609a.33.33 0 01.021.26.343.343 0 01-.174.197l-.655.324a.354.354 0 01-.469-.15l-2.39-4.602c-1.437.97-2.314 2.581-2.314 4.286 0 2.876 2.396 5.215 5.342 5.215s5.343-2.34 5.343-5.214c0-2.876-2.397-5.215-5.343-5.215z",
    fill: "#fff",
    stroke: "null",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBound);
export default __webpack_public_path__ + "static/media/bound.a1b521b1a6ede4cf77c601fc020427cc.svg";
export { ForwardRef as ReactComponent };